import React from 'react';
const Done = () => {
    return (React.createElement("div", { className: "done" },
        React.createElement("h4", null, "Your response has been recorded and results will be shared over email. Feel free to close this window.")));
};
export { Done };
